import React, { ReactNode } from 'react';
import { Card, LabelValueList } from '@routific/hive/v5';
import type { V5LabelValueListItem } from '@routific/hive/v5';

interface Props {
  header: ReactNode;
  headerAddon?: ReactNode;
  rows: V5LabelValueListItem[];
  'data-testid'?: string;
  'data-cy'?: string;
}

const DetailsCard: React.FC<Props> = ({
  header,
  headerAddon,
  rows,
  'data-testid': testId = 'details-card',
  'data-cy': dataCy,
}) => (
  <Card
    header={header}
    headerVariant="body-strong"
    headerAddon={headerAddon}
    data-testid={testId}
    data-cy={dataCy}
  >
    <LabelValueList items={rows} />
  </Card>
);

export default DetailsCard;
